import { BASE_URL } from "./variables";

const businessLogin = async (businessId) => {
    try {
        const response = await fetch(`${BASE_URL}/business-login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImJ1c2luZXNzSWQiOjEsIk1lbWJlcklEIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiZmlyc3ROYW1lIjoiQWRtaW5pc3RyYXRvciIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.AxVVChn_pG_7u8Btwjn_4TMiIu22Tvf9cSIqQKGHeOU",
            },
            body: JSON.stringify({
                BusinessId: businessId
            }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('Business login failed with status:', response.status, errorText);
            throw new Error(`Business login failed: ${response.status}`);
        }

        const data = await response.json();
        
        if (data.success && data.results) {
            // Store the token in localStorage for subsequent API calls
            const token = data.results.accessToken;
            const userId = data.results.userId;
            localStorage.setItem('businessAuthToken', token);
            localStorage.setItem('businessUserId', userId);
            localStorage.setItem('businessId', businessId);
            
            console.log('Business login successful - Token stored:', {
                businessId,
                userId: userId,
                businessAlias: data.businessAlias,
                tokenStored: token
            });
            console.log('Verify localStorage:', localStorage.getItem('businessAuthToken'));
        } else {
            console.error('Business login response missing success or results:', data);
        }
        
        return data;
    } catch (error) {
        console.error("Error during business login:", error);
        throw error;
    }
};

export default businessLogin;
